module.exports = __webpack_public_path__ + "static/media/S14_W.6e08e192.png";